import LoadModel from 'views/3DModels'
import Music from 'views/MusicControl'
import Scene1 from 'views/Scene1'
import Scene3 from 'views/Scene3'
import Scene4 from 'views/Scene4'
import Scene5 from 'views/Scene5'
import Scene6 from 'views/Scene6'
import Scene7 from 'views/Scene7'

let position = ''
// eslint-disable-next-line
let MusicControl = new Music()
let loadmodel = new LoadModel()
let s6
let s5
let s4
let s3

let _isInScene = false
let _sceneName = ''
let _lastScene = ''

/**
 * 场景适配
 * @type {{scene_1: string, scene_2: string, scene_3: string, scene_4: string}}
 */
const SceneOrigin = {
    scene_1: 's3_1',
    scene_2: 's4_1',
    scene_3: 's5_1',
    scene_4: 's6_1',
    scene_5: 's7_1',
}

/**
 * 背景音乐适配
 * @type {{scene_1: string, scene_2: string, scene_3: string, scene_4: string}}
 */
const MusicOrigin = {
    scene_1: 's2_bg',
    scene_2: 's3_bg',
    scene_3: 's4_bg',
    scene_4: 's5_bg',
    scene_5: 's6_bg',
}

const ZOrigin = {
    scene_1: 0,
    scene_2: 300,
    scene_3: 600,
    scene_4: 900,
}

const CenterPosition = {
    scene_1: {x: 0, y: 0, z: 100},
    scene_2: {x: 0, y: 0, z: 200},
    scene_3: {x: 0, y: 0, z: 300},
    scene_4: {x: 0, y: 0, z: 400}
}

const angle2Radian = (angle) => {
    return (Math.PI / 180 * angle).toFixed(7)
}

const formatMusicPosition = (position) => {
    return Math.floor(position * 100000) / 10000
}

const formatVrPos = (x, y, z) => {
    let newX = -((180 - x) % 90).toFixed(3)
    let currentCenterPostion = CenterPosition[_sceneName]

    let tempX = angle2Radian(newX) + currentCenterPostion.x
    let tempY = angle2Radian(y) + currentCenterPostion.y
    let tempZ = +angle2Radian(z) + currentCenterPostion.z
    return {
        x: formatMusicPosition(tempX),
        y: formatMusicPosition(tempY),
        z: formatMusicPosition(tempZ),
    }
}

// window.startup = () => {
//     console.log('全景开始')
//     setTimeout(() => {
//         console.log('全景进行中...')
//         Ending()
//     }, 3000)
//     console.log('全景结束')
//
// }


window.Ending = () => {
    // console.log('开始结束动画^^^^^^')
    loadmodel.stats = 's0_0'
    MusicControl.stopmusic()
    MusicControl.playmusic(-10000, -10000, 1000)
    MusicControl.startmusic('s1_bg')
    MusicControl.jingyin()

    _isInScene = false
    if (loadmodel.stats) {
        loadmodel.stats = null

        if (!loadmodel.animateId) {
            hidePano()
            //console.log('overall')
            MusicControl.startmusic('s1_bg')
            loadmodel.stats = 's7_0'
            new Scene7(loadmodel)
            loadmodel.animateId = window.requestAnimationFrame(loadmodel.animate.bind(loadmodel))
        }
    }
}

/**
 * 场景改变
 *
 * @param name 场景名称
 */
window.onnewscene = (name) => {
    //console.log('场景id:', name);
    _sceneName = name
    _isInScene = true
    // console.log(name)
    // console.log(SceneOrigin[name])
    loadmodel.stats = SceneOrigin[name]
    MusicControl.stopmusic()
    MusicControl.startmusic(MusicOrigin[name])
}

/**
 * 根据角度判断,播放音乐
 *
 * @param ath 摄像机水平角度 0 ~ 360 实时刷新
 * @param atv 摄像机垂直角度 -90 ~ 90 实时刷新
 * @param fov 摄像机fov
 */
window.onviewchange = (ath, atv, fov) => {
    //console.log('摄像机水平角度ath：', ath, ',---摄像机垂直角度atv：', atv, ',----摄像机fov：', fov)
    _lastScene = _sceneName
    const {x, y, z} = formatVrPos(ath, atv, 0)
    //console.log('x:', x, ',y:', y, ',z:', z)
    MusicControl.playmusic(x, y, z)

}

class Main {
    constructor() {
        let url = {
            'url': 'static/models/1100.json',
            'img_url': {
                'vcr': 'static/images/VCR.jpg',
                'pano1_vcr': 'static/images/sky.jpg',
                'pano2': 'static/pano/',
                'suidao': 'static/images/suidao.png'
            },
            'pano1': {'pano': 'static/images/p1/'},
            'pano2': {'pano': 'static/images/p2/'},
            'pano3': {'pano': 'static/images/p3/'},
            'pano4': {'pano': 'static/images/p4/'}
        }
        loadmodel.init(url)
        loadmodel.stats = 's0_0'
        this.check()
    }

    check() {
        if (loadmodel.stats === 's0_1') {
            loadmodel.stats = 's1_0'
            loadmodel.animate()
            // eslint-disable-next-line
            new Scene1(loadmodel)
            MusicControl.startmusic('s1_bg')
        } else if (loadmodel.stats === 'overall') {
            // console.log('overall^^^^^^')
            window.cancelAnimationFrame(loadmodel.animateId)
            loadmodel.animateId = null
            loadmodel.stats = 's0_0'
            MusicControl.stopmusic()
            MusicControl.playmusic(-10000, -10000, 1000)
            MusicControl.startmusic('s1_bg')
            // MusicControl.jingyin()

            if (!this.startingOverall) {
                this.startingOverall = true
                startup()
            }
        }
        // 音乐定位
        if (loadmodel.camera) {
            let center
            let position1
            if (loadmodel.stats === 's2_0') {
                position1 = loadmodel.scene.getObjectByName('s3_lookat_1')
                center = position1.position
            } else if (loadmodel.stats === 's4_0') {
                position1 = loadmodel.scene.getObjectByName('s4_lookat_1')
                center = position1.position
            } else if (loadmodel.stats === 's5_0') {
                position1 = loadmodel.scene.getObjectByName('s5_lookat_1')
                center = position1.position
            } else if (loadmodel.stats === 's6_0') {
                position1 = loadmodel.scene.getObjectByName('s6_lookat_1')
                center = position1.position
            } else {
                center = ''
            }
            let cameraThis = '_X_' + loadmodel.camera.position.x + '_Y_' + loadmodel.camera.position.y + '_Z_' + loadmodel.camera.position.z
            if (cameraThis !== position && center) {
                position = cameraThis
                let x = loadmodel.camera.rotation.x + center.x
                let y = loadmodel.camera.rotation.y + center.y
                let z = loadmodel.camera.rotation.z + center.z
                x = Math.floor(x * 100000) / 10000
                y = Math.floor(y * 100000) / 10000
                z = Math.floor(z * 100000) / 10000
                // console.log('x: ' + x * 10 + ', y: ' + y * 10 + ', z: ' + z * 10)
                MusicControl.playmusic(x, y, z)
            }
        }
        window.requestAnimationFrame(this.check.bind(this))
    }
}

export default Main



// WEBPACK FOOTER //
// ./src/js/mainMidoci.js